/**
 * Function to report web performance metrics.
 * 
 * This function dynamically imports the `web-vitals` module and, if the `onPerfEntry` function is provided and is a function,
 * it will be called with the collected performance metrics.
 * 
 * The performance metrics included are:
 * - CLS (Cumulative Layout Shift)
 * - FID (First Input Delay)
 * - FCP (First Contentful Paint)
 * - LCP (Largest Contentful Paint)
 * - TTFB (Time to First Byte)
 * 
 * @param {Function} onPerfEntry - Function to be called with the performance metrics. Should accept an object with the performance metrics as an argument.
 * 
 * @returns {void}
 */
const reportWebVitals = onPerfEntry => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
      getCLS(onPerfEntry);
      getFID(onPerfEntry);
      getFCP(onPerfEntry);
      getLCP(onPerfEntry);
      getTTFB(onPerfEntry);
    });
  }
};

export default reportWebVitals;
